import React from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
import { appendScriptsCallback } from '../../../helpers/Utils';

export function TradingDealDefinitionInstancePage(): React.ReactElement {
  const currentSecurity = useSecurity('Trading', 'DealDefinitionInstance');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(["Areas/Trading/Scripts/Resources/en/res.DealDefinitionInstance.en.js",
        "Areas/Trading/Scripts/Resources/en/res.DealDefinition.en.js",
        "Areas/Trading/Scripts/Resources/en/res.Trading.en.custom.js",
        "Areas/Trading/Scripts/Resources/en/Types.en.js",
        "Areas/Trading/Scripts/Enums.js",
        "Areas/Trading/Scripts/DealDefinitionInstance/Index.js"], "initTradingDealDefinitionInstance", {});
    }
  }, []);
  return (
    <div className="container-fluid">
      <header className="complete-grid">
        <div id="gridFilter1">
          <div id="gridfilter-toolbar"></div>
        </div>
      </header>
      <section id="gridContainer"></section>
      <ul id="gridContainer-menu"></ul>
    </div>
  );
}
